import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const TermsOfService = lazy(() => import("@/pages/policies/TermsOfService"));

export const Route = createFileRoute("/_public/terms")({
  component: TermsOfService,
});
